module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendarMain_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendarMain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_calendarMain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_calendar_scss__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_calendar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_calendar_scss__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





var Calendar = {};

Calendar.install = function (Vue) {

    var t = new Date();

    Vue.prototype.$calendar = {};

    var CalendarMainCom = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__components_calendarMain_vue___default.a);

    var instance = new CalendarMainCom({
        el: document.createElement('div')
    });
    document.body.appendChild(instance.$el);

    Vue.prototype.$calendar.show = function () {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        instance.show = true;
        var d = '';

        //传入日期，或者已经有选中的日期，就会是初始值
        var date = settings.date || instance.date;
        if (date) {
            try {
                d = date.split('-');
            } catch (e) {
                console.log(e);
                var time = new Date();
                d = [time.getFullYear(), time.getMonth() + 1, time.getDate()];
            }
        } else {
            var _time = new Date();
            d = [_time.getFullYear(), _time.getMonth() + 1, _time.getDate()];
        }

        if (settings.year) {
            console.log(d);
            if (d[0] < settings.year[0] || d[1] > settings.year[1]) {
                d[0] = settings.year[0];
            }
        }
        var _d = d;

        var _d2 = _slicedToArray(_d, 3);

        settings.curYear = _d2[0];
        settings.curMonth = _d2[1];
        settings.curDay = _d2[2];

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* mergeOptions */])(instance, settings);
    };
    Vue.prototype.$calendar.hide = function () {
        instance.show = false;
    };

    Vue.prototype.$calendar.getDate = function () {
        return {
            year: instance.year || new Date().getFullYear(),
            month: instance.month || new Date().getMonth() + 1,
            day: instance.day || new Date().getDay()
        };
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Calendar);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__picker_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__picker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__picker_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            show: false,
            year: [1951, 2050],
            month: [1, 12],
            day: [1, 31],
            curYear: 1951,
            curMonth: 1,
            date: '',
            curDay: 1,
            onOk: function onOk(e) {
                console.log(_this.curYear + '-' + _this.curMonth + '-' + _this.curDay);
            },
            onCancel: function onCancel() {
                console.log('close');
            }
        };
    },
    mounted: function mounted() {},


    computed: {
        isR: function isR() {
            var isR = this.curYear % 4 == 0 ? true : false;
            return isR;
        }
    },
    watch: {
        //初始化的值要判断下日期的范围
        date: function date() {
            this.changeCurVal('year', this.curYear);
            this.changeCurVal('month', this.curMonth);
        }
    },
    components: {
        picker: __WEBPACK_IMPORTED_MODULE_0__picker_vue___default.a
    },
    methods: {
        stop: function stop(e) {
            e.preventDefault();
        },
        close: function close() {
            this.$calendar.hide();
            this.onCancel();
        },
        chose: function chose() {
            this.$calendar.hide();
            var d = this.curYear + '-' + this.curMonth + '-' + this.curDay;
            this.date = this.curYear + '-' + this.curMonth + '-' + this.curDay;
            this.onOk(d);
        },
        changeDataList: function changeDataList() {
            var c2 = this.curMonth == 2;

            var c1 = [1, 3, 5, 7, 8, 10, 12].join().indexOf(this.curMonth);

            if (c2) {
                if (this.isR) {
                    this.day = [1, 29];
                } else {
                    this.day = [1, 28];
                }
            } else if (c1 < 0) {
                this.day = [1, 30];
            } else {
                this.day = [1, 31];
            }
        },
        changeCurVal: function changeCurVal(type, val) {
            if (type == 'year') {
                this.curYear = val;
                this.changeDataList();
            }
            if (type == 'day') {
                this.curDay = val;
            }
            if (type == 'month') {
                this.curMonth = val;
                this.changeDataList();
            }
        }
    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            activeItem: 0,
            itemLength: 0,
            activeItemValue: 0,
            curVal: '', //选中的值
            style: {}, //样式对象
            Y: 0, //
            t: 0.1, //时间
            touchStartTime: 0,
            touchEndTime: 0,
            eY: 34 * 3, //
            sY: 34 * 3, //开始的位置
            isMoving: false, //是否正在滚动
            itemHeight: 34, //每个item的高度
            isR: false //是否是闰年
        };
    },

    props: {
        dataList: {
            type: Array,
            default: []
        },
        defaultVal: [String, Number],
        type: {
            type: String,
            default: ''
        }
    },
    mounted: function mounted() {

        if (this.defaultVal) {
            this.moveTo();
        } else {
            this.style = {
                transform: 'translate3d(0px, ' + this.sY + 'px, 0px)'
            };
        }
    },

    watch: {
        dataList: function dataList() {
            if (this.type == 'day') {}
        }
    },
    computed: {
        dateList: function dateList() {
            var a = [];
            var txt = '';
            switch (this.type) {
                case 'year':
                    txt = '年';break;
                case 'month':
                    txt = '月';break;
                case 'day':
                    txt = '日';break;
                default:
                    txt = '年';
            }

            for (var i = this.dataList[0]; i <= this.dataList[1]; i++) {
                a.push({ txt: i + txt, val: i });
            }
            this.itemLength = a.length;

            if (this.type == 'day') {
                var end = (this.itemLength - 1) * -this.itemHeight + this.itemHeight * 3;
                if (this.eY <= end) {
                    this.Y = end;
                    this.eY = end;
                    this.activeItem = this.itemLength - 1;
                }

                this.style = {
                    transform: 'translate3d(0px, ' + this.eY + 'px, 0px)',
                    transition: 'all ease ' + this.t + 's'
                };

                this.curVal = a[this.activeItem]['val'];

                this.$emit('changeCurVal', this.type, this.curVal);
            }

            return a;
        }
    },
    created: function created() {
        this.itemHeight = this.rem2px(0.8);
    },

    methods: {
        rem2px: function rem2px(d) {
            var val = parseFloat(d) * window.rem;
            if (typeof d === 'string' && d.match(/rem$/)) {
                val += 'px';
            }
            return val;
        },
        start: function start(e) {
            this.sY = e.touches[0].clientY;
            this.touchStartTime = e.timeStamp;
        },

        //初始化有值的时候滚动到某个地方
        moveTo: function moveTo() {
            var _this = this;

            this.dateList.map(function (i, k) {

                if (i.val == _this.defaultVal) {
                    _this.activeItem = k;
                    _this.activeItemValue = i.val;
                }
            });

            this.Y = this.itemHeight * 3 - this.activeItem * this.itemHeight;
            this.eY = this.itemHeight * 3 - this.activeItem * this.itemHeight;

            this.style = {
                transform: 'translate3d(0px, ' + this.Y + 'px, 0px)',
                transition: 'all ease ' + this.t + 's'
            };
        },
        move: function move(e) {

            this.Y = this.eY + e.touches[0].clientY - this.sY;
            //
            this.t = 0.1;
            this.style = {
                transform: 'translate3d(0px, ' + this.Y + 'px, 0px)',
                transition: 'all ease ' + this.t + 's'
            };
        },
        end: function end(e) {

            var m = this.Y;
            var start = this.itemHeight * 3;
            var end = (this.itemLength - 1) * -this.itemHeight + this.itemHeight * 3;
            this.eY = this.Y;
            this.touchEndTime = e.timeStamp - this.touchStartTime;

            this.t = 0.1;

            //没有移动
            if (this.sY == e.changedTouches[0].clientY) {
                return;
            }

            /*
             * 在短时间移动比较大的距离的时候会滑动距离变大
             * */

            if (this.touchEndTime < 220 && Math.abs(e.changedTouches[0].clientY - this.sY) > 100) {

                this.eY = this.eY + (e.changedTouches[0].clientY - this.sY) * this.touchEndTime / 100;
                this.t = 25 / this.touchEndTime * 2;
            };

            //跳转对位
            if (Math.abs(this.eY % this.itemHeight) <= this.itemHeight / 2) {
                this.eY = parseInt(this.eY / this.itemHeight) * this.itemHeight;
            } else {
                if (this.eY > 0) {
                    this.eY = parseInt(this.eY / this.itemHeight) * this.itemHeight + this.itemHeight;
                } else {
                    this.eY = parseInt(this.eY / this.itemHeight) * this.itemHeight - this.itemHeight;
                }
            }

            this.activeItem = Math.abs((this.eY - this.itemHeight * 3) / this.itemHeight);

            //超出范围，滚回去
            if (this.eY > start) {
                this.Y = this.itemHeight * 3;
                this.eY = this.itemHeight * 3;
                this.activeItem = 0;
            }
            if (this.eY <= end) {
                this.Y = end;
                this.eY = end;
                this.activeItem = this.itemLength - 1;
            }

            this.style = {
                transform: 'translate3d(0px, ' + this.eY + 'px, 0px)',
                transition: 'all ease ' + this.t + 's'
            };

            this.curVal = this.dateList[this.activeItem]['val'];

            this.$emit('changeCurVal', this.type, this.curVal);
        }
    }

});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_index__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__modules_index__["a" /* default */]);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mergeOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);


var mergeOptions = function mergeOptions($vm, options) {
  var defaults = {};
  for (var i in $vm.$options.props) {
    if (i !== 'value') {
      defaults[i] = $vm.$options.props[i].default;
    }
  }
  var _options = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, defaults, options);
  for (var _i in _options) {
    $vm[_i] = _options[_i];
  }
};



/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)();
// imports


// module
exports.push([module.i, ".fade-enter-active,.fade-leave-active{transition:opacity .3s;-webkit-transition:opacity .3s;opacity:1}.fade-enter,.fade-leave-to{opacity:0}#app{position:relative;z-index:1}.com-mark{z-index:998;position:fixed;left:0;opacity:0;transition:opacity .2s ease-in}.com-calendar-box{position:fixed;width:100%;height:100%;z-index:1000;top:0;left:0}.com-calendar{position:absolute;bottom:0;left:0;z-index:1000;width:100%;background:#fff}.com-calendar .scroller-component{display:block;flex:1;position:relative;height:5.6rem;overflow:hidden;width:100%}.com-calendar .scroller-content{position:absolute;left:0;top:0;width:100%;z-index:-1}.com-calendar .scroller-mask{position:absolute;left:0;top:0;height:100%;margin:0 auto;width:100%;z-index:3;background-image:linear-gradient(180deg,hsla(0,0%,100%,.95),hsla(0,0%,100%,.6)),linear-gradient(0deg,hsla(0,0%,100%,.95),hsla(0,0%,100%,.6));background-position:top,bottom;background-size:100% 2.4rem;background-repeat:no-repeat}.com-calendar .cal-header{position:relative;width:100%;left:0;height:1rem;bottom:0;border-bottom:1px solid #ddd;background-color:#fff;display:flex;justify-content:space-between}.com-calendar .cal-header>div{height:1rem;line-height:1rem;color:#666;text-align:center;font-size:16px;padding:0 .4rem}[data-dpr=\"2\"] .com-calendar .cal-header>div{font-size:32px}[data-dpr=\"2.5\"] .com-calendar .cal-header>div{font-size:40px}[data-dpr=\"2.75\"] .com-calendar .cal-header>div{font-size:44px}[data-dpr=\"3\"] .com-calendar .cal-header>div{font-size:48px}[data-dpr=\"4\"] .com-calendar .cal-header>div{font-size:64px}.com-calendar .cal-header .dp-right{color:#2167d7}.com-calendar .cal-content{position:relative;display:flex}.com-calendar .scroller-item{text-align:center;font-size:14px;height:.8rem;line-height:.8rem;color:#000}[data-dpr=\"2\"] .com-calendar .scroller-item{font-size:28px}[data-dpr=\"2.5\"] .com-calendar .scroller-item{font-size:35px}[data-dpr=\"2.75\"] .com-calendar .scroller-item{font-size:39px}[data-dpr=\"3\"] .com-calendar .scroller-item{font-size:42px}[data-dpr=\"4\"] .com-calendar .scroller-item{font-size:56px}.com-calendar .scroller-indicator{width:100%;height:.8rem;position:absolute;left:0;top:2.4rem;z-index:2;background-image:linear-gradient(180deg,#d0d0d0,#d0d0d0,transparent,transparent),linear-gradient(0deg,#d0d0d0,#d0d0d0,transparent,transparent);background-position:top,bottom;background-size:100% 1px;background-repeat:no-repeat}.com-calendar .dp-container{position:fixed;width:100%;left:0;bottom:0;z-index:10000;background-color:#fff;transition:transform .3s ease;transform:translateY(0)}.com-calendar .dp-mask{position:fixed;width:100%;height:100%;left:0;top:0;opacity:0;transition:opacity .1s ease;background-color:#000;z-index:9999}.com-calendar .dp-header{display:flex;width:100%;box-align:center;align-items:center;background-image:linear-gradient(180deg,#e7e7e7,#e7e7e7,transparent,transparent);background-position:bottom;background-size:100% 1px;background-repeat:no-repeat}.com-calendar .dp-header .dp-item{color:#666;font-size:18px;height:44px;line-height:44px;cursor:pointer}.com-calendar .dp-content{display:flex;width:100%;box-align:center;align-items:center;padding:10px 0}.com-calendar .dp-content .dp-item,.com-calendar .dp-header .dp-item{box-sizing:border-box;flex:1;text-align:center}.g-calender-content{position:absolute;bottom:0;z-index:1000}.com-mark{background-color:#000;opacity:.5;width:100%;height:100%;top:0;position:absolute;z-index:999}", ""]);

// exports


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./calendar.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./calendar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(2),
  /* template */
  __webpack_require__(13),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(14),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "com-calendar-box"
  }, [(_vm.show) ? _c('div', {
    staticClass: "com-mark",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.stop($event)
      },
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "com-calendar"
  }, [_c('div', {
    staticClass: "cal-header"
  }, [_c('div', {
    staticClass: " dp-left ",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: " dp-right ",
    on: {
      "click": _vm.chose
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "cal-content"
  }, [_c('picker', {
    attrs: {
      "defaultVal": _vm.curYear,
      "dataList": _vm.year,
      "type": "year"
    },
    on: {
      "changeCurVal": _vm.changeCurVal
    }
  }), _vm._v(" "), _c('picker', {
    attrs: {
      "defaultVal": _vm.curMonth,
      "dataList": _vm.month,
      "type": "month"
    },
    on: {
      "changeCurVal": _vm.changeCurVal
    }
  }), _vm._v(" "), _c('picker', {
    attrs: {
      "defaultVal": _vm.curDay,
      "dataList": _vm.day,
      "type": "day"
    },
    on: {
      "changeCurVal": _vm.changeCurVal
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroller-component"
  }, [_c('div', {
    staticClass: "scroller-mask",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.start($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.move($event)
      },
      "touchend": function($event) {
        $event.preventDefault();
        _vm.end($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scroller-indicator"
  }), _vm._v(" "), _c('div', {
    staticClass: "scroller-content",
    style: (_vm.style)
  }, _vm._l((_vm.dateList), function(i) {
    return _c('div', {
      staticClass: "scroller-item "
    }, [_vm._v(_vm._s(i.txt))])
  }))])
},staticRenderFns: []}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js